import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./style.css"
import { useEffect, useRef, useState } from "react";
import { ChevronLeft, Clock, Edit, Heart, LogIn, MessageCircle, Send, Smile, Trash, X, XSquare } from "react-feather";
import GiveCoffeeContent from "./give-coffee-content";
import BottomSheet from "../../../global-components/bottom-sheet/bottom-sheet";
import { User } from "../../../global-components/src/types";
import { useTranslation } from 'react-i18next';



interface GiveCoffeeBottomProps {
    user?: User | null;
    open: boolean;
    setOpen: (open: boolean) => void
}

const GiveCoffeeBottom: React.FC<GiveCoffeeBottomProps> = ({ user, open, setOpen }) => {
    const { t } = useTranslation();
    const closeModalRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        closeModalRef.current?.click();
    }, [location.pathname]); // Executa toda vez que a URL muda

    return (
        <BottomSheet disableDrag snapPoints={[0, 1]} open={open} setOpen={setOpen}>
            <div className="foc-sheet-content">
                <div className="foc-sheet-handle" />
                <div className="foc-sheet-header">
                    <h4 className="foc-sheet-title">{t("coffee.send")}</h4>

                    <button
                        type="button"
                        className="foc-sheet-close"
                        onClick={() => setOpen(false)}
                        aria-label="Fechar"
                    >
                        <X size={16} />
                    </button>
                </div> 
                
                <div className="foc-sheet-body">
                    <GiveCoffeeContent user={user} onClose={() => setOpen(false)}/>
                </div>
            </div>
    </BottomSheet>
    );
};

export default GiveCoffeeBottom;
